// src/components/Footer.js
import React, { useState } from 'react';
import './home.css';
import { NavLink } from 'react-router-dom';
import flogo from '../assets/images/footer-logo.svg';
import { subscription } from '../Adapter/PageAdapter';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Snackbar, Alert } from '@mui/material';

const Footer = () => {

    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadingEmail, setLoadingEmail] = useState(false);
    const [loadingPhone, setLoadingPhone] = useState(false);

    const [thankYouOpen, setThankYouOpen] = useState(false);
    const currentYear = new Date().getFullYear();

    const handleCloseThankYou = () => setThankYouOpen(false);

    const handleEmailSubscribe = async (e) => {
        e.preventDefault();
        if (!email) {
            toast.error("Please enter a valid email address.");
            return;
        }

        setLoadingEmail(true);

        try {
            const response = await subscription({ email, subscription_type: "email" });
            if (response?.message) {
                setThankYouOpen(true);
                setEmail('');
            } else {
                toast.error("Subscription failed. Please try again.");
            }
        } catch (error) {
            toast.error("An error occurred. Please try again.");
        } finally {
            setLoadingEmail(false);
        }
    };

    const handlePhoneSubscribe = async (e) => {
        e.preventDefault();
        if (!phone) {
            toast.error("Please enter a valid phone number.");
            return;
        }

        setLoadingPhone(true);

        try {
            const response = await subscription({ phone, subscription_type: "phone" });
            if (response?.message) {
                setThankYouOpen(true);
                setPhone('');
            } else {
                toast.error("Subscription failed. Please try again.");
            }
        } catch (error) {
            toast.error("An error occurred. Please try again.");
        } finally {
            setLoadingPhone(false);
        }
    };

    return (
        <>
            <ToastContainer />
            <footer className="footer">
                <div className="cust-container">
                    <div className="footer-content foot-add">
                        <div className="footer-section footercol-1">
                            <img src={flogo} alt="Logo" className="footlogo" />
                            <p>
                                We are a premier multispecialty tertiary care hospital in Mumbai, delivering excellence in
                                healthcare across a wide range of specialties, including diabetes management, oncology,
                                cardiac care, critical care, and more. With a rich legacy of innovation, advanced
                                technology, and a deep commitment to compassionate care, we are dedicated to
                                transforming lives and raising the standard of healthcare excellence.
                            </p>
                            <div className="subscribe email-num">
                                {/* <form onSubmit={handleEmailSubscribe}>
                                    <input type="email" placeholder="Enter email" className="subscribe-input" />
                                    <button className="btn with-color" type="submit" disabled={loadingEmail}>
                                        {loadingEmail ? "Subscribing..." : "Subscribe"}
                                    </button>
                                </form> */}
                                <form onSubmit={handleEmailSubscribe}>
                                    <input
                                        type="email"
                                        placeholder="Enter email"
                                        className="subscribe-input"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                    <button type="submit" className="btn with-color" disabled={loading}>
                                        {loading ? "Subscribing..." : "Subscribe"}
                                    </button>
                                </form>
                            </div>
                            <div className="subscribe cont-numm">
                                {/* <form onSubmit={handlePhoneSubscribe}>
                                    <input type="email" placeholder="Contact Number" className="subscribe-input" />
                                    <button className="btn with-color" type="submit" disabled={loadingContact}>
                                        {loadingContact ? "Subscribing..." : "Subscribe"}
                                    </button>
                                </form> */}
                                <form onSubmit={handlePhoneSubscribe}>
                                    <input
                                        type="text"
                                        placeholder="Contact Number"
                                        className="subscribe-input"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                    />
                                    <button type="submit" className="btn with-color" disabled={loading}>
                                        {loading ? "Subscribing..." : "Subscribe"}
                                    </button>
                                </form>
                            </div>
                        </div>
                        <div className="footer-section footercol-2">
                            <div className="foot-section-head">
                                <h4>Quick Links</h4>
                            </div>
                            <ul>
                                <li><NavLink to="/doctor">Find a Doctor</NavLink></li>
                                <li><NavLink  to="/doctor">Book an Appointment</NavLink></li>
                                <li><NavLink to="/health-checkup">Health Check Up</NavLink></li>
                                <li><NavLink to="/opd-schedule">OPD Schedule</NavLink></li>
                                <li><NavLink to="/international-patients">International Patients</NavLink></li>
                                <li><NavLink to="/corporate-tpa">Corporate & TPAs</NavLink></li>
                                <li><NavLink to="/blogs">Blogs</NavLink></li>
                                <li><NavLink to="/career">Careers</NavLink></li>
                                <li><NavLink to="/scope-of-services">Scope of services</NavLink></li>
                                <li><NavLink to="/diabetic-foot-surgery-fellowship">Diabetic Foot Surgery Fellowship</NavLink></li>
                                <li><NavLink to="https://synapse.rahejahospital.com/" target="_blank" rel="noopener noreferrer">Synapse Physio</NavLink></li>
                            </ul>
                        </div>
                        <div className="footer-section footercol-3">
                            <div className="foot-section-head">
                                <h4>Specialties</h4>
                            </div>
                            <ul>
                                <li><NavLink to="/specialities/diabetology">Diabetology</NavLink></li>
                                <li><NavLink to="/specialities/diabetic-foot-surgery">Diabetic Foot Surgery</NavLink></li>
                                <li><NavLink to="/specialities/oncology">Oncology</NavLink></li>
                                <li><NavLink to="/specialities/cardiac-sciences">Cardiac Science</NavLink></li>
                                <li><NavLink to="/specialities/orthopaedics">Orthopaedics</NavLink></li>
                                <li><NavLink to="/specialities/urology">Urology</NavLink></li>
                                <li><NavLink to="/specialities/neurology-neurosurgery">Neurosurgery</NavLink></li>
                                <li><NavLink to="/specialities">View All</NavLink></li>
                            </ul>
                        </div>
                        <div className="footer-section footercol-4">
                            <div className="foot-section-head">
                                <h4>Regulatory<br />
                                    Compliances</h4>
                            </div>
                            <ul>
                                <li><NavLink to="/regulatory-compliance#statutory-monthly-report">Bio-Medical Waste Data</NavLink></li>
                                <li><NavLink to="/regulatory-compliance#stent-pricing">Stent Charges</NavLink></li>
                                <li><NavLink to="/regulatory-compliance#ortho-knee-implant-pricing">Knee Implant Charges</NavLink></li>
                                <li><NavLink to="/regulatory-compliance#organ-transplant-donation-data">Organ Transplant - Donation Data</NavLink></li>
                                <li><NavLink to="/regulatory-compliance#organ-transplant-committee-data">Organ Transplant - Committee Data</NavLink></li>
                            </ul>
                        </div>
                        <div className="footer-section last-foot">
                            <div className="foot-section-head">
                                <h4>Contact Us</h4>
                            </div>
                            <p> 
                                <a 
                                    href="https://maps.app.goo.gl/Mz19gFVtx2GTtj6T8" 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                >
                                S.L. Raheja Hospital - A Fortis Associate,
                                Diabetic Association Of India,
                                Raheja Rugnalaya Marg,
                                Mahim West, Mumbai,
                                Maharashtra, India - 400016
                                </a>
                            </p>
                            <p>Call: <a href="tel:02268846141">022-68846141</a> / <a href="tel:+919167676790">+91 9167676790</a><br /><br />
                                Emergency No: <a href="tel:02266529979">022 66529979</a><br /><br />
                                Email: <a href="mailto:info@rahejahospital.com">info@rahejahospital.com</a></p>
                        </div>
                    </div>
                </div>

            </footer>
            <div className="copy-right">
                <p>© Copyright {currentYear} S.L. Raheja Hospital</p>
            </div>

            {/* Thank You Snackbar */}
            <Snackbar
                open={thankYouOpen}
                autoHideDuration={3000}
                onClose={handleCloseThankYou}
                anchorOrigin={{ vertical: 'center', horizontal: 'center' }}
            >
                <Alert onClose={handleCloseThankYou} severity="success" sx={{ width: '100%' }}>
                    Thank you for subscribing! We have received your details successfully.
                </Alert>
            </Snackbar>
        </>
    );
};

export default Footer;
